function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tablecellproperties/tablecellpropertiesui
 */
import { Plugin } from 'ckeditor5/src/core';
import { ButtonView, clickOutsideHandler, ContextualBalloon, getLocalizedColorOptions, normalizeColorOptions } from 'ckeditor5/src/ui';
import TableCellPropertiesView from './ui/tablecellpropertiesview';
import { colorFieldValidator, getLocalizedColorErrorText, getLocalizedLengthErrorText, defaultColors, lengthFieldValidator, lineWidthFieldValidator } from '../utils/ui/table-properties';
import { debounce } from 'lodash-es';
import { getTableWidgetAncestor } from '../utils/ui/widget';
import { getBalloonCellPositionData, repositionContextualBalloon } from '../utils/ui/contextualballoon';
import tableCellProperties from './../../theme/icons/table-cell-properties.svg';
import { getNormalizedDefaultProperties } from '../utils/table-properties';
var ERROR_TEXT_TIMEOUT = 500; // Map of view properties and related commands.

var propertyToCommandMap = {
  borderStyle: 'tableCellBorderStyle',
  borderColor: 'tableCellBorderColor',
  borderWidth: 'tableCellBorderWidth',
  width: 'tableCellWidth',
  height: 'tableCellHeight',
  padding: 'tableCellPadding',
  backgroundColor: 'tableCellBackgroundColor',
  horizontalAlignment: 'tableCellHorizontalAlignment',
  verticalAlignment: 'tableCellVerticalAlignment'
};
/**
 * The table cell properties UI plugin. It introduces the `'tableCellProperties'` button
 * that opens a form allowing to specify the visual styling of a table cell.
 *
 * It uses the
 * {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon plugin}.
 *
 * @extends module:core/plugin~Plugin
 */

var TableCellPropertiesUI = /*#__PURE__*/function (_Plugin) {
  _inherits(TableCellPropertiesUI, _Plugin);

  var _super = _createSuper(TableCellPropertiesUI);

  /**
   * @inheritDoc
   */
  function TableCellPropertiesUI(editor) {
    var _this;

    _classCallCheck(this, TableCellPropertiesUI);

    _this = _super.call(this, editor);
    editor.config.define('table.tableCellProperties', {
      borderColors: defaultColors,
      backgroundColors: defaultColors
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TableCellPropertiesUI, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var t = editor.t;
      /**
       * The default table cell properties.
       *
       * @protected
       * @member {module:table/tablecellproperties~TableCellPropertiesOptions}
       */

      this._defaultTableCellProperties = getNormalizedDefaultProperties(editor.config.get('table.tableCellProperties.defaultProperties'), {
        includeVerticalAlignmentProperty: true,
        includeHorizontalAlignmentProperty: true,
        includePaddingProperty: true,
        isRightToLeftContent: editor.locale.contentLanguageDirection === 'rtl'
      });
      /**
       * The contextual balloon plugin instance.
       *
       * @private
       * @member {module:ui/panel/balloon/contextualballoon~ContextualBalloon}
       */

      this._balloon = editor.plugins.get(ContextualBalloon);
      /**
       * The cell properties form view displayed inside the balloon.
       *
       * @member {module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView}
       */

      this.view = this._createPropertiesView();
      /**
       * The batch used to undo all changes made by the form (which are live, as the user types)
       * when "Cancel" was pressed. Each time the view is shown, a new batch is created.
       *
       * @protected
       * @member {module:engine/model/batch~Batch}
       */

      this._undoStepBatch = null;
      editor.ui.componentFactory.add('tableCellProperties', function (locale) {
        var view = new ButtonView(locale);
        view.set({
          label: t('Cell properties'),
          icon: tableCellProperties,
          tooltip: true
        });

        _this2.listenTo(view, 'execute', function () {
          return _this2._showView();
        });

        var commands = Object.values(propertyToCommandMap).map(function (commandName) {
          return editor.commands.get(commandName);
        });
        view.bind('isEnabled').toMany(commands, 'isEnabled', function () {
          for (var _len = arguments.length, areEnabled = new Array(_len), _key = 0; _key < _len; _key++) {
            areEnabled[_key] = arguments[_key];
          }

          return areEnabled.some(function (isCommandEnabled) {
            return isCommandEnabled;
          });
        });
        return view;
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(TableCellPropertiesUI.prototype), "destroy", this).call(this); // Destroy created UI components as they are not automatically destroyed.
      // See https://github.com/ckeditor/ckeditor5/issues/1341.


      this.view.destroy();
    }
    /**
     * Creates the {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView} instance.
     *
     * @private
     * @returns {module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView} The cell
     * properties form view instance.
     */

  }, {
    key: "_createPropertiesView",
    value: function _createPropertiesView() {
      var _this3 = this;

      var editor = this.editor;
      var viewDocument = editor.editing.view.document;
      var config = editor.config.get('table.tableCellProperties');
      var borderColorsConfig = normalizeColorOptions(config.borderColors);
      var localizedBorderColors = getLocalizedColorOptions(editor.locale, borderColorsConfig);
      var backgroundColorsConfig = normalizeColorOptions(config.backgroundColors);
      var localizedBackgroundColors = getLocalizedColorOptions(editor.locale, backgroundColorsConfig);
      var view = new TableCellPropertiesView(editor.locale, {
        borderColors: localizedBorderColors,
        backgroundColors: localizedBackgroundColors,
        defaultTableCellProperties: this._defaultTableCellProperties
      });
      var t = editor.t; // Render the view so its #element is available for the clickOutsideHandler.

      view.render();
      this.listenTo(view, 'submit', function () {
        _this3._hideView();
      });
      this.listenTo(view, 'cancel', function () {
        // https://github.com/ckeditor/ckeditor5/issues/6180
        if (_this3._undoStepBatch.operations.length) {
          editor.execute('undo', _this3._undoStepBatch);
        }

        _this3._hideView();
      }); // Close the balloon on Esc key press.

      view.keystrokes.set('Esc', function (data, cancel) {
        _this3._hideView();

        cancel();
      }); // Reposition the balloon or hide the form if a table cell is no longer selected.

      this.listenTo(editor.ui, 'update', function () {
        if (!getTableWidgetAncestor(viewDocument.selection)) {
          _this3._hideView();
        } else if (_this3._isViewVisible) {
          repositionContextualBalloon(editor, 'cell');
        }
      }); // Close on click outside of balloon panel element.

      clickOutsideHandler({
        emitter: view,
        activator: function activator() {
          return _this3._isViewInBalloon;
        },
        contextElements: [this._balloon.view.element],
        callback: function callback() {
          return _this3._hideView();
        }
      });
      var colorErrorText = getLocalizedColorErrorText(t);
      var lengthErrorText = getLocalizedLengthErrorText(t); // Create the "UI -> editor data" binding.
      // These listeners update the editor data (via table commands) when any observable
      // property of the view has changed. They also validate the value and display errors in the UI
      // when necessary. This makes the view live, which means the changes are
      // visible in the editing as soon as the user types or changes fields' values.

      view.on('change:borderStyle', this._getPropertyChangeCallback('tableCellBorderStyle', this._defaultTableCellProperties.borderStyle));
      view.on('change:borderColor', this._getValidatedPropertyChangeCallback({
        viewField: view.borderColorInput,
        commandName: 'tableCellBorderColor',
        errorText: colorErrorText,
        validator: colorFieldValidator,
        defaultValue: this._defaultTableCellProperties.borderColor
      }));
      view.on('change:borderWidth', this._getValidatedPropertyChangeCallback({
        viewField: view.borderWidthInput,
        commandName: 'tableCellBorderWidth',
        errorText: lengthErrorText,
        validator: lineWidthFieldValidator,
        defaultValue: this._defaultTableCellProperties.borderWidth
      }));
      view.on('change:padding', this._getValidatedPropertyChangeCallback({
        viewField: view.paddingInput,
        commandName: 'tableCellPadding',
        errorText: lengthErrorText,
        validator: lengthFieldValidator,
        defaultValue: this._defaultTableCellProperties.padding
      }));
      view.on('change:width', this._getValidatedPropertyChangeCallback({
        viewField: view.widthInput,
        commandName: 'tableCellWidth',
        errorText: lengthErrorText,
        validator: lengthFieldValidator,
        defaultValue: this._defaultTableCellProperties.width
      }));
      view.on('change:height', this._getValidatedPropertyChangeCallback({
        viewField: view.heightInput,
        commandName: 'tableCellHeight',
        errorText: lengthErrorText,
        validator: lengthFieldValidator,
        defaultValue: this._defaultTableCellProperties.height
      }));
      view.on('change:backgroundColor', this._getValidatedPropertyChangeCallback({
        viewField: view.backgroundInput,
        commandName: 'tableCellBackgroundColor',
        errorText: colorErrorText,
        validator: colorFieldValidator,
        defaultValue: this._defaultTableCellProperties.backgroundColor
      }));
      view.on('change:horizontalAlignment', this._getPropertyChangeCallback('tableCellHorizontalAlignment', this._defaultTableCellProperties.horizontalAlignment));
      view.on('change:verticalAlignment', this._getPropertyChangeCallback('tableCellVerticalAlignment', this._defaultTableCellProperties.verticalAlignment));
      return view;
    }
    /**
     * In this method the "editor data -> UI" binding is happening.
     *
     * When executed, this method obtains selected cell property values from various table commands
     * and passes them to the {@link #view}.
     *
     * This way, the UI stays up–to–date with the editor data.
     *
     * @private
     */

  }, {
    key: "_fillViewFormFromCommandValues",
    value: function _fillViewFormFromCommandValues() {
      var _this4 = this;

      var commands = this.editor.commands;
      var borderStyleCommand = commands.get('tableCellBorderStyle');
      Object.entries(propertyToCommandMap).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            property = _ref2[0],
            commandName = _ref2[1];

        var defaultValue = _this4._defaultTableCellProperties[property] || '';
        return [property, commands.get(commandName).value || defaultValue];
      }).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            property = _ref4[0],
            value = _ref4[1];

        // Do not set the `border-color` and `border-width` fields if `border-style:none`.
        if ((property === 'borderColor' || property === 'borderWidth') && borderStyleCommand.value === 'none') {
          return;
        }

        _this4.view.set(property, value);
      });
    }
    /**
     * Shows the {@link #view} in the {@link #_balloon}.
     *
     * **Note**: Each time a view is shown, a new {@link #_undoStepBatch} is created. It contains
     * all changes made to the document when the view is visible, allowing a single undo step
     * for all of them.
     *
     * @protected
     */

  }, {
    key: "_showView",
    value: function _showView() {
      var editor = this.editor; // Update the view with the model values.

      this._fillViewFormFromCommandValues();

      this._balloon.add({
        view: this.view,
        position: getBalloonCellPositionData(editor)
      }); // Create a new batch. Clicking "Cancel" will undo this batch.


      this._undoStepBatch = editor.model.createBatch(); // Basic a11y.

      this.view.focus();
    }
    /**
     * Removes the {@link #view} from the {@link #_balloon}.
     *
     * @protected
     */

  }, {
    key: "_hideView",
    value: function _hideView() {
      if (!this._isViewInBalloon) {
        return;
      }

      var editor = this.editor;
      this.stopListening(editor.ui, 'update'); // Blur any input element before removing it from DOM to prevent issues in some browsers.
      // See https://github.com/ckeditor/ckeditor5/issues/1501.

      this.view.saveButtonView.focus();

      this._balloon.remove(this.view); // Make sure the focus is not lost in the process by putting it directly
      // into the editing view.


      this.editor.editing.view.focus();
    }
    /**
     * Returns `true` when the {@link #view} is visible in the {@link #_balloon}.
     *
     * @private
     * @type {Boolean}
     */

  }, {
    key: "_isViewVisible",
    get: function get() {
      return this._balloon.visibleView === this.view;
    }
    /**
     * Returns `true` when the {@link #view} is in the {@link #_balloon}.
     *
     * @private
     * @type {Boolean}
     */

  }, {
    key: "_isViewInBalloon",
    get: function get() {
      return this._balloon.hasView(this.view);
    }
    /**
     * Creates a callback that when executed upon the {@link #view view's} property change
     * executes a related editor command with the new property value.
     *
     * @private
     * @param {String} commandName
     * @param {String} defaultValue The default value of the command.
     * @returns {Function}
     */

  }, {
    key: "_getPropertyChangeCallback",
    value: function _getPropertyChangeCallback(commandName, defaultValue) {
      var _this5 = this;

      return function (evt, propertyName, newValue, oldValue) {
        // If the "oldValue" is missing and "newValue" is set to the default value, do not execute the command.
        // It is an initial call (when opening the table properties view).
        if (!oldValue && defaultValue === newValue) {
          return;
        }

        _this5.editor.execute(commandName, {
          value: newValue,
          batch: _this5._undoStepBatch
        });
      };
    }
    /**
     * Creates a callback that when executed upon the {@link #view view's} property change:
     * * Executes a related editor command with the new property value if the value is valid,
     * * Or sets the error text next to the invalid field, if the value did not pass the validation.
     *
     * @private
     * @param {Object} options
     * @param {String} options.commandName
     * @param {module:ui/view~View} options.viewField
     * @param {Function} options.validator
     * @param {String} options.errorText
     * @param {String} options.defaultValue
     * @returns {Function}
     */

  }, {
    key: "_getValidatedPropertyChangeCallback",
    value: function _getValidatedPropertyChangeCallback(options) {
      var _this6 = this;

      var commandName = options.commandName,
          viewField = options.viewField,
          validator = options.validator,
          errorText = options.errorText,
          defaultValue = options.defaultValue;
      var setErrorTextDebounced = debounce(function () {
        viewField.errorText = errorText;
      }, ERROR_TEXT_TIMEOUT);
      return function (evt, propertyName, newValue, oldValue) {
        setErrorTextDebounced.cancel(); // If the "oldValue" is missing and "newValue" is set to the default value, do not execute the command.
        // It is an initial call (when opening the table properties view).

        if (!oldValue && defaultValue === newValue) {
          return;
        }

        if (validator(newValue)) {
          _this6.editor.execute(commandName, {
            value: newValue,
            batch: _this6._undoStepBatch
          });

          viewField.errorText = null;
        } else {
          setErrorTextDebounced();
        }
      };
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ContextualBalloon];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'TableCellPropertiesUI';
    }
  }]);

  return TableCellPropertiesUI;
}(Plugin);

export { TableCellPropertiesUI as default };